import axios, { AxiosInstance } from 'axios'
// eslint-disable-next-line
import { getToken, getCsrfToken } from '@/utils/auth'
import store from '@/store'
import stores from '@/stores'
import { getOldLang } from './settings'
import { Toast, Dialog } from 'vant'
import { cGoBack } from './const'
// eslint-disable-next-line
const config = require('../../config')
const { baseURL } = config[process.env.NODE_ENV]

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Accept-Language': getOldLang() || 'tc',
    'CMHS-User-Agent': navigator.userAgent,
    'User-Agent': navigator.userAgent,
  }
  // withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers.Authorization = `Bearer ${getToken()}`
    }
    // if (store.state.user.token) {
    //   config.headers.Authorization = `Bearer ${getToken()}`
    // }
    // config.headers['x-csrf-token'] = getCsrfToken()
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code !== 200) {
    //   return Promise.reject(res)
    // } else {
    return response
    // }
  },
  error => {
    if (error && error?.response && error?.response?.status) {
      switch (error?.response?.status) {
        case 401:
          // token失效
          //   Dialog.alert({
          //     title: '提示',
          //     message: '您还未登录或登录已过期，请重新登录'
          //   }).then(() => {

          //   })
          Toast('您还未登录或登录已过期，请重新登录')
          store.dispatch('user/signOut').then(() => {
            window.location.replace('cmcchkhsh://login')
          })
          break
        case 500:
          // token失效
          alert('當前網絡狀況差，請檢查網絡')
          break
        default:
          Toast(error.message)
          break
      }
    }
    return Promise.reject(error)
  }
)

export default service
